import { useState } from 'react';
import { Header } from './Header';
import { MenuItem } from '../types/type';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './utility/ProtectedRoute';
import { LazyLoader } from './utility/LazyLoader';
import { routes } from './utility/route';
import { NotFound } from './NotFound';
import { MainSidebar } from './Sidebar/MainSidebar';

interface LayoutProps {
  menu: MenuItem[];
}

export const Layout = ({ menu }: any) => {
  const [collapsed, setCollapsed] = useState(false);
  const isAuthenticated = true;

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  return (
    <div className='min-h-screen flex'>
      {/* Sidebar Section */}
      <div className='fixed left-0 top-0 h-screen flex' style={{ zIndex: 10 }}>
        <MainSidebar menu={menu} collapsed={collapsed} toggleCollapse={toggleSidebar} />
      </div>
      {/* Main Content Section */}
      <div className={`flex-1 transition-all duration-300 ${collapsed ? 'ml-20' : 'ml-64'}`}>
        {' '}
        <Header />
        <main className='bg-background min-h-[calc(140vh-64px)] mb-20'>
          {' '}
          {/* Assuming header height is 64px */}
          <LazyLoader>
            <Routes>
              {routes.map(({ path, component: Component, protected: isProtected }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    isProtected ? (
                      <ProtectedRoute isAuthenticated={isAuthenticated} authenticationPath='/login'>
                        <Component />
                      </ProtectedRoute>
                    ) : (
                      <Component />
                    )
                  }
                />
              ))}
              <Route path='*' element={<NotFound />} />
            </Routes>
          </LazyLoader>
        </main>
      </div>
    </div>
  );
};
